export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-10 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-[300px] h-[300px] rounded-full bg-secondary-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: text content */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>51黑料 · 91黑料 · 17黑料 · 718黑料</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 leading-tight">
              黑料
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-700 font-normal mt-1">
                数字黑料品牌聚合入口
              </span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-medium max-w-xl mx-auto lg:mx-0">
              一站汇聚 · 实时更新 · 安全浏览
            </p>

            <div className="mt-6 space-y-2 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                黑料聚合51黑料网、91黑料网、17黑料网等主流数字黑料子品牌入口，
                提供51黑料最新地址、17黑料吃瓜视频、718黑料合集等热门内容。
                无论你是寻找91黑料入口还是追踪51黑料最新动态，这里都是你的一站式浏览起点。
              </p>
              <p>
                平台每日更新黑料资源，覆盖多品牌最新发布，确保你第一时间获取数字黑料系列的全部精彩内容。
              </p>
            </div>

            {/* Stats */}
            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500">4+</div>
                <div className="text-xs text-foreground-500 mt-1">核心子品牌</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-500">每日</div>
                <div className="text-xs text-foreground-500 mt-1">持续更新</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-secondary-500">安全</div>
                <div className="text-xs text-foreground-500 mt-1">加密访问</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览热门索引
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-background-100 text-foreground-800 font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200/70"
              >
                查看人气榜单
                <i className="ri-bar-chart-line"></i>
              </a>
            </div>
          </div>

          {/* Right: visual */}
          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative overflow-hidden rounded-2xl bg-background-100 border border-background-200/70 aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20dark%20themed%20digital%20content%20hub%20with%20glowing%20neon%20orange%20and%20warm%20amber%20accent%20lights%2C%20abstract%20geometric%20data%20visualization%20patterns%2C%20floating%20digital%20cards%20with%20trending%20labels%2C%20futuristic%20portal%20entrance%20design%2C%20cinematic%20atmospheric%20lighting%2C%20dark%20gradient%20background%20with%20subtle%20grid%20lines%2C%20premium%20editorial%20style%2C%208k%20quality&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                  alt="黑料数字内容聚合平台主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/30 to-transparent"></div>
              </div>
              {/* Floating accent elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 rounded-xl bg-primary-500/10 border border-primary-200/30 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-500"></i>
              </div>
              <div className="absolute -bottom-3 -left-3 w-16 h-16 rounded-xl bg-accent-500/10 border border-accent-200/30 flex items-center justify-center">
                <i className="ri-flashlight-line text-xl text-accent-500"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}